<template>
  <div id="contenedor-main-contrato-ejecucion">
    <v-container fluid>
      <v-card flat>
        <v-card-text>
          <titulo-tool-bar :titulo="getContrato.numero"></titulo-tool-bar>
          <opciones-tool-bar></opciones-tool-bar>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- Rutas -->
    <v-container
      fluid>
      <router-view></router-view>
    </v-container>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import TituloToolBar from './TituloToolBar.vue';
import OpcionesToolBar from './OpcionesToolBar.vue';

export default {
  name: 'MainContratoEjecucion',
  components: {
    TituloToolBar,
    OpcionesToolBar,
  },
  data() {
    return {};
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
  },
};
</script>

<style lang="scss">

</style>
